<template>
  <div class="game page">
    <div class="phone-stage">
      <div class="box">
        <div class="want-row">
          <span class="want-label">{{ $t('game.want') }}</span>
        </div>

        <div class="opt-grid">
          <div
            v-for="(item, index) in gameitem"
            :key="item.id || index"
            class="opt"
            :class="{ active: index === tabs2Index }"
            @click="tabs2Index = index"
          >
            <em class="opt-name">{{ item.name }}</em>
            <div class="opt-ico-wrap">
              <img
                v-if="iconSrc(item)"
                class="opt-ico"
                :src="iconSrc(item)"
                alt=""
                @error="onIconError(item)"
              />
              <div v-else class="opt-ico opt-ico--empty"></div>
            </div>
          </div>
        </div>

        <van-button
          class="start-btn"
          round
          block
          type="primary"
          color="linear-gradient(to right, #f7c1c9 0%, #ff556e 100%)"
          @click="toGame"
        >
          {{ $t('game.start_love') }}
        </van-button>
      </div>
    </div>

    <div v-if="isLoading" class="loading">
      <img src="/img/game1.jpg" alt="" />
      <span class="loader2"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'game_n',
  data() {
    return {
      gameitem: [],
      isLoading: false,
      tabs2Index: 0,
      iconBroken: {},
    }
  },
  methods: {
    mediaUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url) || url.startsWith('data:')) return url
      const base = process.env.NODE_ENV === 'development' ? '' : 'https://d2h0m7gk9kbvfa.cloudfront.net'
      if (url.startsWith('/')) return `${base}${url}`
      return `${base}/${url}`
    },
    iconSrc(item) {
      if (!item || this.iconBroken[item.id || item.key || item.name]) return ''
      return this.mediaUrl(item.ico || item.image || item.cover || '')
    },
    onIconError(item) {
      const key = item.id || item.key || item.name
      this.$set(this.iconBroken, key, true)
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list',
      })
        .then((res) => {
          const list = res && res.data
          if (Array.isArray(list) && list.length) {
            this.gameitem = list
            this.tabs2Index = 0
          } else {
            this.gameitem = [
              { name: 'Datum 1', key: '', id: '', ico: '' },
              { name: 'Datum 2', key: '', id: '', ico: '' },
              { name: '111', key: '', id: '', ico: '' },
            ]
          }
        })
        .catch(() => {
          this.gameitem = [
            { name: 'Datum 1', key: '', id: '', ico: '' },
            { name: 'Datum 2', key: '', id: '', ico: '' },
            { name: '111', key: '', id: '', ico: '' },
          ]
        })
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
        return
      }
      if (!key && !id) {
        this.$toast(this.$t('reservation.choose_num') || '请选择')
        return
      }
      this.$router.push({ path: '/Lottery?key=' + key + '&id=' + id })
    },
    /** 播放加载动画期间请求游戏数据，就绪后再进入 */
    toGame() {
      const item = this.gameitem[this.tabs2Index] || {}
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
        return
      }
      if (!item.key && !item.id) {
        this.$toast(this.$t('reservation.choose_num') || '请选择')
        return
      }
      if (this.isLoading) return
      this.isLoading = true
      const startedAt = Date.now()
      const minAnimMs = 1200

      Promise.all([
        this.$http({ method: 'get', url: 'lottery_get_info', data: { key: item.key } }),
        this.$http({ method: 'get', url: 'lottery_get_one_list', data: { key: item.key } }),
        this.$http({ method: 'get', url: 'lottery_get_peilv', data: { id: item.id } }),
        this.$http({ method: 'get', url: 'user_info' }),
      ])
        .then(([infoRes, listRes, peilvRes, userRes]) => {
          if (userRes && userRes.code === 401) {
            this.$toast(userRes.msg)
            this.isLoading = false
            this.$router.push({ path: '/Login' })
            return
          }
          if (!infoRes || infoRes.code !== 200) {
            this.$toast((infoRes && infoRes.msg) || '加载失败')
            this.isLoading = false
            return
          }
          const userMoney = userRes && userRes.code === 200 ? userRes.data.money : null
          if (
            userMoney != null &&
            infoRes.data &&
            infoRes.data.condition != null &&
            parseFloat(userMoney) < parseFloat(infoRes.data.condition)
          ) {
            this.$toast(this.$t('reservation.contact_admin'))
            this.isLoading = false
            this.$router.push({ path: '/Home' })
            return
          }
          if ((listRes && listRes.code === 401) || (peilvRes && peilvRes.code === 401)) {
            this.$toast((listRes && listRes.msg) || (peilvRes && peilvRes.msg) || '加载失败')
            this.isLoading = false
            return
          }

          const wait = Math.max(0, minAnimMs - (Date.now() - startedAt))
          setTimeout(() => {
            // 保持动画到路由切换，避免中间露出默认页
            this.$router.push({ path: '/Lottery?key=' + item.key + '&id=' + item.id })
          }, wait)
        })
        .catch(() => {
          this.$toast('加载失败')
          this.isLoading = false
        })
    },
  },
  created() {
    this.getGameItem()
  },
}
</script>

<style lang="less" scoped>
/* 全部用 cqw：相对 #app 宽度，手机/桌面限宽预览都不会缩成小卡片 */
.game.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url(/img/game1.jpg) no-repeat center center;
  background-size: cover;
  box-sizing: border-box;
  padding-bottom: 14cqw;
}

.phone-stage {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40cqw 3cqw 4cqw;
  box-sizing: border-box;
}

.box {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 5.333cqw;
  border: 0.533cqw solid #ffd5db;
  padding: 5.333cqw 4cqw 6.4cqw;
  box-sizing: border-box;
  box-shadow: 0 2.133cqw 5.333cqw rgba(255, 85, 110, 0.16);
}

.want-row {
  margin-bottom: 4cqw;
}

.want-label {
  font-size: 4.267cqw;
  color: #666;
  font-weight: 500;
}

.opt-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3.2cqw;
}

.opt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 3.2cqw 1.6cqw 4cqw;
  border-radius: 3.733cqw;
  background: #fff7f8;
  border: 0.267cqw solid transparent;
  cursor: pointer;
  box-sizing: border-box;
  min-height: 32cqw;

  &.active {
    background: #fec5cc;
    border-color: #ff8395;

    .opt-name {
      color: #fff;
    }
  }
}

/* 名称在上、图标在下 */
.opt-name {
  display: block;
  width: 100%;
  text-align: center;
  font-style: normal;
  font-size: 3.467cqw;
  line-height: 1.35;
  color: #333;
  margin: 0 0 2.667cqw;
  word-break: break-all;
  font-weight: 500;
}

.opt-ico-wrap {
  width: 16cqw;
  height: 16cqw;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  flex-shrink: 0;
  box-shadow: 0 0.533cqw 1.6cqw rgba(0, 0, 0, 0.06);
}

.opt-ico {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.opt-ico--empty {
  background: linear-gradient(135deg, #ffe4e8, #ffc9d2);
}

.start-btn {
  margin-top: 6.4cqw !important;
  height: 12.8cqw !important;
  line-height: 12.8cqw !important;
  font-size: 4.267cqw !important;
  font-weight: 600 !important;
  border: none !important;
}

.loading {
  position: fixed;
  inset: 0;
  background: #fea4a6;
  z-index: 2000;

  img {
    position: absolute;
    width: 150%;
    left: 0;
    top: 0;
    height: 100%;
    object-fit: cover;
    opacity: 0.85;
  }

  .loader2 {
    transform: rotate(45deg);
    perspective: 250px;
    border-radius: 50%;
    width: 16.533cqw;
    height: 16.533cqw;
    color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .loader2:before,
  .loader2:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    transform: rotateX(70deg);
    animation: game-spin 1s linear infinite;
  }

  .loader2:after {
    transform: rotateY(70deg);
    animation-delay: 0.4s;
  }
}

@keyframes game-spin {
  0%,
  100% {
    box-shadow: 0.2em 0 0 0 currentcolor;
  }
  12% {
    box-shadow: 0.2em 0.2em 0 0 currentcolor;
  }
  25% {
    box-shadow: 0 0.2em 0 0 currentcolor;
  }
  37% {
    box-shadow: -0.2em 0.2em 0 0 currentcolor;
  }
  50% {
    box-shadow: -0.2em 0 0 0 currentcolor;
  }
  62% {
    box-shadow: -0.2em -0.2em 0 0 currentcolor;
  }
  75% {
    box-shadow: 0 -0.2em 0 0 currentcolor;
  }
  87% {
    box-shadow: 0.2em -0.2em 0 0 currentcolor;
  }
}
</style>
